import { render } from "./filter.vue?vue&type=template&id=e0810dd4"
import script from "./filter.vue?vue&type=script&lang=js"
export * from "./filter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\21-century-edm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__